import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaSpacing } from 'yoda-ui/yodaTheme';

export const formLayoutPaddingTop = fromUnitsToRem(YodaSpacing.medium);

export const formLayoutStickyStyles: SxProps<Theme> = {
  position: 'sticky',
  top: `calc(6rem + ${formLayoutPaddingTop})`,
  alignSelf: 'start',
};
